/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { checkToken } from '@builddocs/data-management'
import axios from 'axios'

const FilestoreAPI = axios.create({
  baseURL: '/filestore/api/v1',
})

FilestoreAPI.interceptors.request.use(checkToken)

export { FilestoreAPI }
